export type RowSegment = { x: number; y: number; widthCells: number };

export function rangeToRowSegments(
  start: number,
  end: number,
  gridWidth: number,
  memorySize: number
): RowSegment[] {
  if (memorySize <= 0 || gridWidth <= 0) return [];

  const first = Math.max(0, Math.min(memorySize - 1, Math.min(start, end)));
  const last = Math.max(0, Math.min(memorySize - 1, Math.max(start, end)));
  const segments: RowSegment[] = [];

  let addr = first;
  while (addr <= last) {
    const y = Math.floor(addr / gridWidth);
    const rowEnd = Math.min(last, (y + 1) * gridWidth - 1);
    segments.push({
      x: addr % gridWidth,
      y,
      widthCells: rowEnd - addr + 1,
    });
    addr = rowEnd + 1;
  }

  return segments;
}
